import { h } from 'preact';

import SkyItModalWithPanel from '../../../components/3-molecules/sky-it-modal-with-panel/sky-it-modal-with-panel';
import SkyItPanel from '../../../components/3-molecules/sky-it-panel/sky-it-panel';
import { parseImagesForPanels } from '../../../utils/parsers';

export const renderModalTooltip = ({ modalTooltipData, pageState, pageHandlers, htmlId }) => {
  const images = parseImagesForPanels(modalTooltipData.images);
  const dataPanel = {
    ...modalTooltipData,
    images,
    hasInfo: true,
    hasImageCentered: true,
    paginationItems: [
      {
        linkLabel: '1',
        onClick: () => pageHandlers.handleModalTooltipPageClick(0),
      },
      {
        linkLabel: '2',
        onClick: () => pageHandlers.handleModalTooltipPageClick(1),
      },
    ],
    selectedPage: pageState.modalTooltip.selectedPage,
    description: images[pageState.modalTooltip.selectedPage]?.description,
  };

  return (
    <SkyItModalWithPanel
      onCancel={pageHandlers.handleModalTooltipClose}
      isActive={pageState.modalTooltip.widgetId === htmlId}
    >
      <SkyItPanel onCtaPrimaryClick={pageHandlers.handleModalTooltipClose} {...dataPanel} />
    </SkyItModalWithPanel>
  );
};
